<template lang="pug">
  .cancel-sub-modal.narrow-modal-body.xs-f-small.max-at-tweak
    SectionTitle(text="Cancel Subscription" data-mr-ass="cancel-sub-modal").text-center
    p We want you to love your hair. Our professional colorists are standing by &mdash; and your next box is
      span.bold &nbsp;free
      | .

    SupportCtas(:hide='["email"]')

    hr
    .row.modal-link-section(@click="editAutoDeliveryFrequencyModal({ subId: subInEdit.id })")
      .xs-12.bold.color-mr-purple Change Frequency
      .xs-12 Change order frequency
      span.icon-caret-right.color-slate.xs-f-medium.max-at-tweak
    hr
    .row.modal-link-section(@click="editAutoDeliveryChangeColorModal({ subId: subInEdit.id, theme: changeColorTheme })")
      .xs-12.bold.color-mr-purple Change Color
      .xs-12 Try something new or different
      span.icon-caret-right.color-slate.xs-f-medium.max-at-tweak
    hr
    .row.modal-link-section(@click="openPostponeModal({ subId: subInEdit.id })")
      .xs-12.bold.color-mr-purple Postpone subscription
      .xs-12 Already have what you need, or taking a vacation?
      span.icon-caret-right.color-slate.xs-f-medium.max-at-tweak
    hr

    SubmitButtons(
      submit-text="Cancel Subscription"
      :submit-method="editAutoDeliveryCancelReasonsModal"
      submit-class="btn-inverse"
      cancel-text="Back"
      :cancel-method="hideModal"
    )
  
</template>

<script>
  import { mapActions, mapState } from "vuex";
  import SectionTitle from "../../../SectionTitle";
  import SubmitButtons from "../../../SubmitButtons";
  import SupportCtas from "../../../SupportCtas";

  export default {
    name: "EditAutoDeliveryCancelModal",
    components: {
      SupportCtas,
      SubmitButtons,
      SectionTitle
    },

    computed: {
      ...mapState('subscriptions', [
        'subInEdit'
      ]),

      changeColorTheme() {
        if (this.subInEdit && this.subInEdit.product_info && this.subInEdit.product_info.product_type == 'color_kit') {
          return 'try-it-on-modal';
        }
        return 'default';
      }
    },

    methods: {
      ...mapActions('subscriptions', [
        'editAutoDeliveryCancelReasonsModal',
        'editAutoDeliveryFrequencyModal',
        'editAutoDeliveryChangeColorModal',
        'openPostponeModal'
      ]),

      ...mapActions('modal', ['hideModal'])
    }
  }
</script>

<style scoped lang="stylus">
  .cancel-sub-modal
    p
      padding 2em 0

    .modal-link-section
      cursor pointer
      padding 1.2em 1.5em

    .icon-caret-right
      color color-mr-purple
      position absolute
      top 50%
      margin-top -0.75em
      right 1.2em

    .support-ctas
      padding-bottom 2em

    .submit-buttons
      padding-top 3em

</style>